import React from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import DefaultCrew from "../../../../layouts/DefaultCrew";
import Template from "../../../../templates/Crew/Arrival/ServerUpdate/ServerUpdateArrivalConfirm";
import { Form, LocationState } from "../Create/types";
import { UpdateArrivalDocument } from "../../../../../gen/graphql/types";
import { pageData, useContextIDs } from "../../../../../App";
import { useMutation } from "@apollo/client";
import { mapToArrivalMutationVariables } from "../arrival.module";
import useErrorMessageList from "../../../../../hooks/errorMessage.hook";

type LocationForm = {
  form: Form;
};

const ServerUpdateArrivalConfirm = (
  props: LocationState
): React.ReactElement => {
  const { ship_id } = useContextIDs();
  const { reportId } = useParams<"reportId">();
  const { errorMessageList, addErrorMessage } = useErrorMessageList();
  const navigate = useNavigate();

  const [updateArrival, { error }] = useMutation(UpdateArrivalDocument);

  if (reportId === undefined) navigate("/");

  const report_id = Number(reportId);

  const location = useLocation();

  const location_form = location.state as LocationForm;

  if (!props.form && !location_form.form) {
    navigate(-1);
  }

  const form = props.form || location_form.form;

  const onUpdate = async () => {
    try {
      const variables = mapToArrivalMutationVariables(form, ship_id, report_id);

      updateArrival({
        fetchPolicy: "network-only",
        variables: { input: variables },
        onCompleted: (data) => {
          try {
            if (!data) {
              throw `Server Update error! ${data}`;
            }
            navigate(pageData.serverUpdateArrivalComplete.path());
          } catch (error) {
            console.error(error);
            addErrorMessage({
              input: JSON.stringify(variables),
              errorMessage: `Server Update error! ${error}`,
            });
          }
        },
        onError: (error) => {
          console.error(error);
          addErrorMessage({
            input: JSON.stringify(variables),
            errorMessage: `Server Update error! ${error}`,
          });
        },
      });
    } catch (e) {
      console.error(e);
      console.error(error);
      return;
    }
  };

  const onBack = () => {
    if (!reportId) return;
    navigate(pageData.serverUpdateArrival.path(reportId), {
      state: { form: form },
    });
  };

  return (
    <DefaultCrew title="" selectedTitle={"Arrival"}>
      <Template
        form={location_form.form}
        isLoading={false}
        onUpdate={onUpdate}
        onBack={onBack}
        reportId={report_id}
        errorMessageList={errorMessageList}
      />
    </DefaultCrew>
  );
};

export default ServerUpdateArrivalConfirm;
